export const headerSelector = {
  buttons: {
    signup: "header-sign-up",
    upgrade: "header-upgrade",
    hamburguer: "header-hamburguer",
  },
};
